export default __webpack_public_path__ + "static/media/025-claw machine.5019f840.svg";